import { HelmetProvider } from "react-helmet-async";
import "./App.sass";
import { Logic } from "./logic";
import React, { Suspense } from "react";
import { RouteParamList } from "./modules/playground/route-params";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

const PlaygroundModule = React.lazy(
  () => import("./modules/playground/PlaygroundModule")
);
const PrivacyPolicy = React.lazy(() => import("./components/PrivacyPolicy"));
const Terms = React.lazy(() => import("./components/Terms"));
const CountriesModule = React.lazy(
  () => import("./modules/Countries/CountriesModule")
);

const logic = new Logic();
export const LogicContext = React.createContext<Logic>(logic);

export function useLogic() {
  return React.useContext(LogicContext);
}

export type WithLogic = {
  logic: Logic;
};

export function withLogicContext<P extends WithLogic>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof WithLogic>> {
  return function BoundComponent(props: Omit<P, keyof WithLogic>) {
    return (
      <LogicContext.Consumer>
        {(value) => <Component {...(props as unknown as P)} logic={value} />}
      </LogicContext.Consumer>
    );
  };
}

interface Props {
  logic: Logic;
}

interface State { }

function PlaygroundRoute() {
  const location = useLocation();
  const pathname = location.pathname.replace(/^\/|\/$/g, "");
  const [list = "", tag = "", year = ""] = pathname.split("/");

  return (
    <PlaygroundModule
      routeParams={{
        list: list as RouteParamList,
        tag,
        year: year ? Number(year) : undefined,
      }}
    />
  );
}

class App extends React.Component<Props, State> {
  componentWillUnmount() { }

  componentDidMount(): void { }

  render() {
    const { logic } = this.props;

    const helmetContext = {};

    return (
      <HelmetProvider context={helmetContext}>
        <LogicContext.Provider value={logic}>
          <Suspense fallback="Loading...">
            <Router>
              {/* <div className="App">
                <NavbarModule />
              </div> */}
              <Routes>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/countries" element={<CountriesModule />} />

                <Route
                  path="*"
                  element={<PlaygroundRoute />}
                />
              </Routes>
            </Router>
          </Suspense>
        </LogicContext.Provider>
      </HelmetProvider>
    );
  }
}

export default App;
